export function resolveTurnstileToken(container: HTMLElement | null): string | null {
  if (!container) {
    return null;
  }

  const token = String(container.dataset['turnstileToken'] ?? '').trim();
  return token === '' ? null : token;
}
